import { api } from './api';

export interface Notification {
  id: number;
  user_id: number;
  type: string;
  title: string;
  message: string | null;
  related_type: string | null;
  related_id: number | null;
  action_url: string | null;
  read_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface NotificationListResponse {
  success: boolean;
  data: {
    current_page: number;
    data: Notification[];
    total: number;
    per_page: number;
  };
}

export interface UnreadCountResponse {
  success: boolean;
  data: {
    count: number;
  };
}

export const notificationService = {
  getNotifications: async (type?: string): Promise<NotificationListResponse> => {
    const params = type ? { type } : {};
    const response = await api.get('/notifications', { params });
    return response.data;
  },

  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  markAsRead: async (notificationId: number): Promise<void> => {
    await api.post(`/notifications/${notificationId}/mark-as-read`);
  },

  markAllAsRead: async (): Promise<void> => {
    await api.post('/notifications/mark-all-as-read');
  },

  markSelectedAsRead: async (ids: number[]): Promise<void> => {
    await api.post('/notifications/mark-selected-as-read', { ids });
  },

  markAsReadByComment: async (commentId: number): Promise<void> => {
    await api.post(`/notifications/mark-read-by-comment/${commentId}`);
  },
};












